import action from '../helpers/rest-client'
import { filtersString } from '../helpers/getFiltersString'
import { paginationString } from '../helpers/getPaginationString'
import {
  NewResponsibleOutDto,
  EditResponsibleOutDto,
  DeleteResponsibleOutDto,
  GetOneResponsibleOutDto,
  GetAllResponsiblesOutDto,
} from '../types/responsible.dto'

const path = '/responsible'

class Responsible {
  public new(payload: NewResponsibleOutDto) {
    return action
      .Post({
        url: `${path}`,
        body: payload,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public edit({ idResponsible, ...rest }: EditResponsibleOutDto) {
    return action
      .Patch({
        url: `${path}/${idResponsible}`,
        body: rest.body,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public async getAll({ filters, pagination, sort, group }: GetAllResponsiblesOutDto) {
    const filtersJSON = filters && Object.keys(filters).length > 0 ? `&filters=${JSON.stringify(filters)}` : ''

    return action
      .Get({
        url: `${path}/paginated/${paginationString({ pagination, sort, group })}${filtersJSON}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public getOne({ idResponsible }: GetOneResponsibleOutDto) {
    return action
      .Get({
        url: `${path}/${idResponsible}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }

  public deleteOne({ idResponsible }: DeleteResponsibleOutDto) {
    return action
      .Get({
        url: `${path}/${idResponsible}`,
      })
      .then(response => {
        return { response }
      })
      .catch(error => {
        return { error }
      })
  }
}

const responsible = new Responsible()
export default responsible
